import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlobalErrorService {
  private _show = signal<boolean>(false);
  private _report = signal<string>('');
  /* Track whether the error is from backend (health check failed) or client. */
  private _isServerError = signal<boolean>(false);
  readonly visible = this._show.asReadonly();
  /* Diagnostic report for the currently shown error, copyable from the dialog. */
  readonly report = this._report.asReadonly();
  /* True if error is from backend/health check, false if client-side/network. */
  readonly isServerError = this._isServerError.asReadonly();

  /*
  * Shows the global error dialog. No-op if it is already visible, so multiple
  * failed requests don't stack dialogs or trigger repeated health checks.
  * Returns true if the dialog was opened by this call, false if it was already open.
  * `report` is the copyable diagnostic text for this error.
  * `isServerError` indicates if the error source is the backend (true) or client (false).
  * */
  open(report?: string, isServerError = false): boolean {
    if (this._show()) return false;
    if (report !== undefined) this._report.set(report);
    this._isServerError.set(isServerError);
    this._show.set(true);
    return true;
  }

  close() {
    this._show.set(false);
  }
}
